import { FileWriterBase } from './file-writer-base';

export class JsonWriterProps extends FileWriterBase {
	rootKeyName = 'data';

	constructor(init?: Partial<JsonWriterProps>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
